import React from 'react';
import { toast } from 'react-toastify';
import images from '../../assets/images';
import { APPROVAL_MODAL } from '../../context/general/constants';
import { useGeneralDispatch, useGeneralState } from '../../context/general/generalContext';
import { useRequest } from '../../hooks/useRequest';

const ApprovalModal = () => {
  const { approvalModal } = useGeneralState();
  const dispatch = useGeneralDispatch();
  const { request } = useRequest();
  const handleDelete = () => {
    request('post/deletePost', {
      method: 'DELETE',
      body: {
        postId: approvalModal.detail.id
      }
    }).then((res) => {
      if (res.statusText == 'OK') {
        toast.success('Post Silindi');
        closeModal();
      }
    });
  };
  const closeModal = () => {
    dispatch({
      type: APPROVAL_MODAL,
      payload: { open: false }
    });
  };
  return (
    <div className="approval-modal">
      <div className="approval-modal--content">
        <div className="approval-modal--content--close" onClick={closeModal}>
          <img src={images.iconClose} alt="Close Icon" />
        </div>
        <div className="approval-modal--content--title">
          Paylaşımı Silmek İstediğinize Emin Misiniz?
        </div>
        <div className="approval-modal--content--buttons">
          <div className="approval-modal--content--buttons--ok" onClick={handleDelete}>
            Evet
          </div>
          <div className="approval-modal--content--buttons--cancel" onClick={closeModal}>
            Hayır
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalModal;
